import { RouteIcon } from "lucide-react";
import { Track } from "../../types";
import { Box, Typography } from "@mui/material";
import AddNewTrack from "./add-new-track";

export default function LinkedTracksEmptyState({
  track,
}: Readonly<{ track: Track }>) {
  return (
    <Box
      sx={(theme) => ({
        background: theme.nawy.colors.semantic.layer.primary,
        borderRadius: theme.nawy.radius.xl,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        gap: theme.nawy.spacing.sm,
      })}
    >
      <RouteIcon size={24} />
      <Typography
        sx={(theme) => theme.nawy.typography.english.variants.headline.sm}
      >
        No linked tracks yet
      </Typography>
      <Typography
        sx={(theme) => theme.nawy.typography.english.variants.body.md.regular}
      >
        This property has no other tracks yet.
      </Typography>

      <AddNewTrack track={track} />
    </Box>
  );
}
